import Icon from "@ant-design/icons";

const icon = () => (
  <svg
    height="1em"
    viewBox="-59 0 512 512"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m323.992188 273.453125c-4.171876 0-7.554688 3.382813-7.554688 7.558594v181.683593c0 15.34375-12.484375 27.828126-27.828125 27.828126-15.773437 0-28.128906-11.6875-28.128906-26.609376v-35.449218c0-23.675782-19.261719-42.941406-42.941407-42.941406-23.675781 0-42.941406 19.265624-42.941406 42.941406v68.0625c0 4.171875 3.382813 7.558594 7.558594 7.558594 4.171875 0 7.554688-3.386719 7.554688-7.558594v-68.0625c0-15.34375 12.484374-27.828125 27.828124-27.828125 15.347657 0 27.828126 12.484375 27.828126 27.828125v35.449218c0 23.394532 18.996093 41.722657 43.242187 41.722657 23.675781 0 42.941406-19.261719 42.941406-42.941407v-181.683593c0-4.175781-3.382812-7.558594-7.558593-7.558594zm0 0"
      fill="#ecedef"
    />
    <path
      d="m131.664062 125.625h-73.808593c-4.171875 0-7.554688 3.382812-7.554688 7.554688v42.699218c0 4.175782 3.382813 7.558594 7.554688 7.558594h73.808593c4.171876 0 7.554688-3.382812 7.554688-7.558594v-42.699218c0-4.171876-3.382812-7.554688-7.554688-7.554688zm0 0"
      fill="#2b5be2"
    />
    <path
      d="m131.664062 125.625h-23.175781c4.171875 0 7.554688 3.382812 7.554688 7.554688v42.699218c0 4.175782-3.382813 7.558594-7.554688 7.558594h23.175781c4.171876 0 7.554688-3.382812 7.554688-7.558594v-42.699218c0-4.171876-3.382812-7.554688-7.554688-7.554688zm0 0"
      fill="#2052e0"
    />
    <path
      d="m181.964844 168.324219h-174.40625c-4.175782 0-7.558594 3.382812-7.558594 7.554687v27.589844l10.074219 125.285156-10.074219 148.097656v27.589844c0 4.175782 3.382812 7.558594 7.558594 7.558594h174.402344c4.175781 0 7.558593-3.382812 7.558593-7.558594v-27.589844l-10.078125-148.097656 10.078125-125.285156v-27.589844c0-4.171875-3.382812-7.554687-7.554687-7.554687zm0 0"
      fill="#0075ff"
    />
    <path
      d="m189.519531 175.878906c0-4.171875-3.382812-7.554687-7.554687-7.554687h-23.175782c4.171876 0 7.554688 3.382812 7.554688 7.554687v27.589844l-10.074219 125.285156 10.074219 148.097656v27.589844c0 4.175782-3.382812 7.558594-7.554688 7.558594h23.175782c4.171875 0 7.554687-3.382812 7.554687-7.558594v-27.589844l-10.074219-148.097656 10.074219-125.285156zm0 0"
      fill="#2052e0"
    />
    <path
      d="m341.484375 198.570312c-4.171875 0-7.554687-3.382812-7.554687-7.558593v-37.726563c0-4.175781 3.382812-7.558594 7.554687-7.558594 4.175781 0 7.558594 3.382813 7.558594 7.558594v37.726563c0 4.175781-3.382813 7.558593-7.558594 7.558593zm0 0"
      fill="#646464"
    />
    <path
      d="m308.285156 198.570312c-4.175781 0-7.558594-3.382812-7.558594-7.558593v-37.726563c0-4.175781 3.382813-7.558594 7.558594-7.558594 4.171875 0 7.554688 3.382813 7.554688 7.558594v37.726563c0 4.175781-3.382813 7.558593-7.554688 7.558593zm0 0"
      fill="#646464"
    />
    <path
      d="m0 203.46875h189.519531v273.382812h-189.519531zm0 0"
      fill="#e480be"
    />
    <path
      d="m166.34375 203.46875h23.175781v273.382812h-23.175781zm0 0"
      fill="#d96cba"
    />
    <path
      d="m361.003906 183.457031h-74.023437c-4.175781 0-7.558594 3.382813-7.558594 7.554688v47.886719c0 24.578124 19.996094 44.570312 44.570313 44.570312 24.574218 0 44.570312-19.996094 44.570312-44.570312v-47.886719c0-4.171875-3.382812-7.554688-7.558594-7.554688zm0 0"
      fill="#d0cfd1"
    />
    <path
      d="m361.003906 183.457031h-23.175781c4.175781 0 7.558594 3.382813 7.558594 7.554688v47.886719c0 20.566406-14.007813 37.917968-32.980469 43.03125 3.695312 1 7.578125 1.539062 11.585938 1.539062 24.578124 0 44.570312-19.996094 44.570312-44.570312v-47.886719c0-4.171875-3.382812-7.554688-7.558594-7.554688zm0 0"
      fill="#b6b6b6"
    />
    <path
      d="m157.738281 320.542969c-1.304687-2.484375-3.882812-4.039063-6.6875-4.039063h-45.375l8.605469-74.078125c.414062-3.558593-1.730469-6.917969-5.128906-8.042969-3.402344-1.132812-7.128906.289063-8.921875 3.390626l-63.4375 109.695312c-1.335938 2.304688-1.355469 5.144531-.054688 7.46875 1.296875 2.328125 3.726563 3.796875 6.386719 3.867188l40.738281 1.117187-16.1875 72.953125c-.785156 3.53125 1.042969 7.121094 4.363281 8.566406.976563.421875 2 .628906 3.011719.628906 2.425781 0 4.78125-1.171874 6.226563-3.277343l75.996094-110.449219c1.59375-2.3125 1.769531-5.316406.464843-7.800781zm0 0"
      fill="#f9cd45"
    />
    <path
      d="m157.738281 320.542969c-1.304687-2.484375-3.882812-4.039063-6.6875-4.039063h-23.175781c2.804688 0 5.382812 1.554688 6.6875 4.039063s1.128906 5.488281-.460938 7.800781l-63.804687 92.734375-2.617187 11.796875c-.785157 3.53125 1.042968 7.121094 4.359374 8.566406.976563.425782 2 .628906 3.015626.628906 2.425781 0 4.78125-1.171874 6.226562-3.273437l75.996094-110.449219c1.589844-2.316406 1.765625-5.320312.460937-7.804687zm0 0"
      fill="#ffac1f"
    />
    <path
      d="m82.503906 316.503906h23.171875l8.605469-74.078125c.414062-3.558593-1.730469-6.917969-5.128906-8.042969-3.402344-1.132812-7.128906.289063-8.921875 3.390626l-10.742188 18.574218zm0 0"
      fill="#ffac1f"
    />
    <path
      d="m359.960938 75.609375c-3.59375 0-6.503907-2.910156-6.503907-6.503906 0-16.246094-13.214843-29.464844-29.464843-29.464844-16.246094 0-29.464844 13.21875-29.464844 29.464844 0 3.59375-2.910156 6.503906-6.5 6.503906s-6.503906-2.910156-6.503906-6.503906c0-23.414063 19.054687-42.46875 42.46875-42.46875 23.417968 0 42.46875 19.050781 42.46875 42.46875 0 3.59375-2.910157 6.503906-6.5 6.503906zm0 0"
      fill="#d0cfd1"
    />
    <path
      d="m386.597656 75.609375c-3.589844 0-6.5-2.910156-6.5-6.503906 0-30.933594-25.167968-56.101563-56.105468-56.101563-30.933594 0-56.101563 25.167969-56.101563 56.101563 0 3.59375-2.914063 6.503906-6.503906 6.503906-3.589844 0-6.5-2.910156-6.5-6.503906 0-38.105469 31-69.105469 69.105469-69.105469 38.105468 0 69.105468 31 69.105468 69.105469 0 3.59375-2.910156 6.503906-6.5 6.503906zm0 0"
      fill="#d0cfd1"
    />
    <path
      d="m323.992188 54.113281c-9.703126 0-17.59375 7.890625-17.59375 17.59375 0 9.699219 7.894531 17.59375 17.59375 17.59375 9.703124 0 17.597656-7.894531 17.597656-17.59375 0-9.703125-7.894532-17.59375-17.597656-17.59375zm0 0"
      fill="#f45a3c"
    />
    <path
      d="m323.992188 54.113281c-3.699219 0-7.132813 1.152344-9.96875 3.109375 4.601562 3.179688 7.628906 8.484375 7.628906 14.484375 0 6.003907-3.027344 11.304688-7.628906 14.480469 2.835937 1.960938 6.269531 3.113281 9.96875 3.113281 9.703124 0 17.597656-7.894531 17.597656-17.59375 0-9.703125-7.894532-17.59375-17.597656-17.59375zm0 0"
      fill="#eb4c36"
    />
  </svg>
);

const IconEvCharger = (props) => <Icon component={icon} {...props} />;

export default IconEvCharger;
